/**
 * The admin tab registry: which slugs exist and what each one is called.
 *
 * This lived inside AdminDashboard, which meant adding a tab required editing
 * two files that had no way of noticing each other — the sidebar that renders
 * the link, and this map, which decides whether a URL slug is real. The day
 * "Traineri" was added only the first was touched. The link appeared, looked
 * entirely normal, and clicking it bounced to Leaduri, because an unknown slug
 * falls back to the default rather than showing anything wrong.
 *
 * Pulled out here so both sides import the same thing, and so a test can hold
 * them against each other without dragging the router into scope.
 */
export const TAB_TITLES = {
  leads: "Leaduri",
  enrollments: "Înscrieri",
  contracts: "Contracte",
  purchases: "Plăți",
  consents: "Consimțăminte marketing",
  referrals: "Recomandări",
  groups: "Grupe curs",
  trainers: "Traineri",
  portal: "Portal",
  webinars: "Webinarii",
  certificates: "Adeverințe",
  analytics: "Analytics",
  settings: "Setări curs",
  tickets: "Tichete",
  ghid: "Ghid",
  signature: "Semnătură email",
  users: "Utilizatori",
  security: "Securitate",
  audit: "Audit",
};

/** Unknown slugs fall back to the default so nobody lands on a blank tab. */
export const VALID_TABS = new Set(Object.keys(TAB_TITLES));

export const DEFAULT_TAB = "leads";
